import axios from "axios";

let controller= [];
let responsesData= [];

export async function getProductPriceListByGroup(productIdAndUnitList) {
    const requestKey = productIdAndUnitList
        .map(productIdentifiers => `${productIdentifiers.productCode ?? ''}-${productIdentifiers.unitCode ?? ''}`)
        .join(',');

    if (responsesData[requestKey]) {
        return responsesData[requestKey];
    }
    if (controller[requestKey]) {
        controller[requestKey].abort();
    }
    controller[requestKey] = new AbortController();

    try {
        const res = await axios
            .post(
                'ajax/prices',
                {
                    productIdAndUnitList: productIdAndUnitList,
                },
                {
                    signal: controller[requestKey].signal
                },
            );

        responsesData[requestKey] = res.data;
        return res.data;
    } catch (e) {
        return '';
    }
}